/**
 * Created by Rodrigo Quesada on 04/01/17.
 */
import {LocalDateInterval} from '../../../common/values/local-date-interval.class';

export class AttendanceDuration {
    duration?: LocalDateInterval = {};
    explanation?: string;

    constructor(jsonData: any = {}) {
        if (jsonData.duration) jsonData.duration = new LocalDateInterval(jsonData.duration);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/common/values/attendance-duration.class.ts